import { css } from '@emotion/core';

export const customerStatFilterDialogButtonsCSS = css`
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;

    button {
        height: 2.5rem;
        min-width: 5rem;
    }
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
`;

export const customerStatFilterDialogCancelApplyContainerCSS = css`
    display: flex;
    gap: 0.5rem;
`;

export const customerStatFilterDialogApplySaveFilterButtonCSS = ({ colors }) => css`
    &:disabled {
        background-color: ${colors.disabledLightGrey};
        border-color: ${colors.disabledLightGrey};
        color: ${colors.disabledDarkGrey};
    }
`;

export const statFilterDialogCSS = css`
    height: 80vh;
    width: 80vw;
    max-width: 72rem;
    max-height: 39rem;
    font-size: 0.75rem;
`;
